import { createPrefixer } from '.'

const ROOT = 'ver-convenios' as const
export const RESOURCE_CONVENIOS = 'Convenios' as const
const rp = <T extends string>(mod: T): `${typeof ROOT}-${T}` => `${ROOT}-${mod}`
const pc = createPrefixer(ROOT, 'configuracion')
const pt = createPrefixer(ROOT, 'transacciones')

const permission = {
    _root: ROOT,
    _resource: RESOURCE_CONVENIOS,
    configuracion: {
        _perm: rp('configuracion'),
        tipoConvenio: pc('tipo-convenio'),
        nivelAprobacion: pc('niveles-aprobacion'),
    },
    transacciones: {
        _perm: rp('transacciones'),
        convenios: {
            _perm: pt('convenios'),
            gestionConvenios: pt('gestion-convenios'),
            creacionConvenio: pt('crear-convenio'),
            aprobacionConvenio: pt('aprobacion-convenio'),
        },
    },
}

export default permission
